/* eslint-disable @typescript-eslint/no-explicit-any */

/**
 * docs: https://yandex.ru/support/metrica/general/goal-js-event.html
 */
function ym({
  counterId,
  method,
  event,
  data,
}: {
  counterId?: number;
  method: string;
  event: string;
  data: string;
}) {
  if (typeof window === 'undefined') {
    return;
  }

  const _ym = (window as any).ym;
  if (!_ym) {
    console.warn(
      `DID'T SENT: ym('${counterId}', '${method}', '${event}', ${JSON.stringify(
        data,
        null,
        2,
      )})`,
    );
    return false;
  }

  if (!counterId) {
    counterId = (window as any).Ya.Metrika2.counters()[0].id;
  }

  _ym(counterId, method, event, data);

  console.log(
    `ym('${counterId}', '${method}', '${event}', ${JSON.stringify(
      data,
      null,
      2,
    )})`,
  );

  return true;
}

/**
 * docs: https://developers.google.com/analytics/devguides/collection/analyticsjs/events
 */
function ga(
  method: string,
  args: {
    hitType: string;
    eventCategory: string;
    eventAction: string;
    eventLabel?: string;
  },
) {
  if (typeof window === 'undefined') {
    return;
  }

  const _ga = (window as any).ga;
  if (!_ga) {
    console.warn(
      `DID'T SENT: ga('${method}', ${JSON.stringify(args, null, 2)})`,
    );
    return false;
  }

  _ga(method, args);

  console.log(`ga('${method}', ${JSON.stringify(args, null, 2)})`);

  return true;
}

const goal = {
  ym({ labels, data }: { labels: string | Array<string>; data?: any }) {
    if (!Array.isArray(labels)) {
      labels = [labels];
    }
    labels.forEach((label) => {
      ym({
        method: 'reachGoal',
        event: label,
        data,
      });
    });
  },

  ga({
    category,
    action,
    labels,
  }: {
    category: string;
    action: string;
    labels?: null | string | Array<string | null | undefined>;
  }) {
    if (!Array.isArray(labels)) {
      labels = [labels];
    }
    labels.forEach((label) => {
      ga('send', {
        hitType: 'event',
        eventCategory: category,
        eventAction: action,
        eventLabel: label || void 0,
      });
    });
  },
};

export default {
  goal,
};
